import { render, staticRenderFns } from "./cookies-consent.vue?vue&type=template&id=f176f21a&"
import script from "./cookies-consent.vue?vue&type=script&lang=js&"
export * from "./cookies-consent.vue?vue&type=script&lang=js&"
import style0 from "./cookies-consent.vue?vue&type=style&index=0&id=f176f21a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports